module.exports = __webpack_public_path__ + "static/media/Hosting-Deliveroo-Bag.afa929d6.jpg";